import type { RecursiveRequired, Settings } from '#/global'
import { cloneDeep } from 'es-toolkit'
import settingsDefault from '@/settings.default'
import { merge } from '@/utils/object'

const globalSettings: Settings.all = {
  app: {
    lightTheme: 'blue',
    darkTheme: 'blue',
    enablePermission: false,
  },
  menu: {
    mode: 'single',
  },
  toolbar: {
    navSearch: false,
  },
  mainPage: {
    enableHotkeys: false,
  },
  navSearch: {
    enableHotkeys: false,
  },
  layout: {
    enableMobileAdaptation: true,
  },
  tabbar: {
    enable: true,
    style: 'fashion',
  },
  topbar: {
    mode: 'fixed',
  },
  copyright: {
    enable: true,
    customer: '裕霖书院专属应用',
    dates: '2025-2026',
    company: '云奕智（深圳）信息科技有限公司',
    website: '',
    beian: '粤ICP备2025407320号-1',
  },
}

export default merge(globalSettings, cloneDeep(settingsDefault)) as RecursiveRequired<Settings.all>
